import script from "./RegisterPrivacyPolicyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterPrivacyPolicyModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterPrivacyPolicyModal.vue?vue&type=style&index=0&id=11501811&lang=scss"

const __exports__ = script;

export default __exports__